import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import { v5, v4 } from 'uuid';
import _includes from 'lodash/includes';

// Define UUID_NAMESPACE for uuidv5
var UUID_NAMESPACE = '29cc8a0d-747c-5f85-9ff9-f2f16636d963';
function getWebManifest() {
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var browserData = getBrowserDetails(userAgent);
    return {
        userAgent: userAgent,
        platform: platform,
        browserName: browserData.name,
        browserVersion: browserData.version,
        browserOs: browserData.os,
    };
}
function browserName(userAgent, vendor, opera) {
    vendor = vendor || ''; // vendor is undefined for at least IE9
    if (opera || _includes(userAgent, ' OPR/')) {
        if (_includes(userAgent, 'Mini')) {
            return 'Opera Mini';
        }
        return 'Opera';
    }
    else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
        return 'BlackBerry';
    }
    else if (_includes(userAgent, 'IEMobile') || _includes(userAgent, 'WPDesktop')) {
        return 'Internet Explorer Mobile';
    }
    else if (_includes(userAgent, 'SamsungBrowser/')) {
        // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
    }
    else if (_includes(userAgent, 'Edge') || _includes(userAgent, 'Edg/')) {
        return 'Microsoft Edge';
    }
    else if (_includes(userAgent, 'FBIOS')) {
        return 'Facebook Mobile';
    }
    else if (_includes(userAgent, 'Chrome')) {
        return 'Chrome';
    }
    else if (_includes(userAgent, 'CriOS')) {
        return 'Chrome iOS';
    }
    else if (_includes(userAgent, 'UCWEB') || _includes(userAgent, 'UCBrowser')) {
        return 'UC Browser';
    }
    else if (_includes(userAgent, 'FxiOS')) {
        return 'Firefox iOS';
    }
    else if (_includes(vendor, 'Apple')) {
        if (_includes(userAgent, 'Mobile')) {
            return 'Mobile Safari';
        }
        return 'Safari';
    }
    else if (_includes(userAgent, 'Android')) {
        return 'Android Mobile';
    }
    else if (_includes(userAgent, 'Konqueror')) {
        return 'Konqueror';
    }
    else if (_includes(userAgent, 'Firefox')) {
        return 'Firefox';
    }
    else if (_includes(userAgent, 'MSIE') || _includes(userAgent, 'Trident/')) {
        return 'Internet Explorer';
    }
    else if (_includes(userAgent, 'Gecko')) {
        return 'Mozilla';
    }
    else {
        return 'Unknown';
    }
}
function browserVersion(userAgent, vendor, opera) {
    var browser = browserName(userAgent, vendor, opera);
    var versionRegexs = {
        'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
        'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
        Chrome: /Chrome\/(\d+(\.\d+)?)/,
        'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
        'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
        Safari: /Version\/(\d+(\.\d+)?)/,
        'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
        Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
        Firefox: /Firefox\/(\d+(\.\d+)?)/,
        'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
        Konqueror: /Konqueror:(\d+(\.\d+)?)/,
        BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
        'Android Mobile': /android\s(\d+(\.\d+)?)/,
        'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
        'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
        Mozilla: /rv:(\d+(\.\d+)?)/,
    };
    var regex = versionRegexs[browser];
    if (regex === undefined) {
        return null;
    }
    var matches = userAgent.match(regex);
    if (!matches) {
        return 'Unknown';
    }
    return parseFloat(matches[matches.length - 2]);
}
function browserOs(userAgent) {
    var a = userAgent;
    if (/Windows/i.test(a)) {
        if (/Phone/.test(a) || /WPDesktop/.test(a)) {
            return 'Windows Phone';
        }
        return 'Windows';
    }
    else if (/(iPhone|iPad|iPod)/.test(a)) {
        return 'iOS';
    }
    else if (/Android/.test(a)) {
        return 'Android';
    }
    else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
        return 'BlackBerry';
    }
    else if (/Mac/i.test(a)) {
        return 'Mac OS X';
    }
    else if (/Linux/.test(a)) {
        return 'Linux';
    }
    else if (/CrOS/.test(a)) {
        return 'Chrome OS';
    }
    else {
        return 'Unknown';
    }
}
var getBrowserDetails = (function () {
    var detailsByUserAgent = {};
    return function (userAgent) {
        if (!detailsByUserAgent[userAgent]) {
            detailsByUserAgent[userAgent] = {
                name: browserName(userAgent, navigator.vendor, window.opera),
                version: browserVersion(userAgent, navigator.vendor, window.opera),
                os: browserOs(userAgent),
            };
        }
        return detailsByUserAgent[userAgent];
    };
})();
/**
 * Equivalent to Expo's Platform manifest
 */
function getBrowserPlatformManifest() {
    var manifest = {};
    if (navigator.userAgent) {
        manifest.web = getWebManifest();
        manifest.scheme = window.location.protocol.replace(':', '');
        manifest.hostUri = window.location.host;
    }
    return manifest;
}
function getDeviceIdAsync() {
    return __awaiter(this, void 0, void 0, function () {
        var deviceId;
        return __generator(this, function (_a) {
            if (localStorage.getItem('deviceId')) {
                // delete deprecated deviceId
                localStorage.removeItem('deviceId');
            }
            deviceId = v5("".concat(navigator.platform), UUID_NAMESPACE);
            return [2 /*return*/, deviceId];
        });
    });
}
/**
 * Function to get installation ID, considering web environment
 */
function getInstallationId(bundleIdentifier, userId) {
    var installationId = v5("".concat(bundleIdentifier, "-").concat(userId), UUID_NAMESPACE);
    return installationId;
}
/**
 * Main function to build app installation info for web
 */
var buildAppInstallationInfo = function (_a) {
    var userId = _a.userId, appId = _a.appId;
    return __awaiter(void 0, void 0, void 0, function () {
        var appInstallation, installationIdGenerated, installationId, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    appInstallation = {
                        deviceInfo: {
                            deviceId: null,
                            deviceIdDeprecated: null,
                            deviceYearClass: null,
                            isDevice: true,
                        },
                        appInfo: {
                            appId: appId,
                            appOwnership: null,
                            browserName: getBrowserDetails(navigator.userAgent).name,
                            debugMode: process.env.NODE_ENV === 'development',
                            executionEnvironment: 'browser',
                            experienceUrl: window.location.href,
                            expoRuntimeVersion: null,
                            expoVersion: null,
                            webViewUserAgent: navigator.userAgent,
                            installationIdGenerated: '',
                            installationId: '',
                            isHeadless: false,
                            linkingUri: window.location.href,
                            linkingUrl: window.location.href,
                            name: document.title,
                            platform: 'Unknown',
                            nativeAppVersion: null,
                            nativeBuildVersion: null,
                            sessionId: v4(),
                            statusBarHeight: 0,
                            timezoneOffsetInHours: new Date().getTimezoneOffset() / 60,
                        },
                    };
                    installationIdGenerated = getInstallationId(appId, userId);
                    installationId = installationIdGenerated;
                    appInstallation.deviceInfo.deviceName = navigator.userAgent;
                    _b = appInstallation.deviceInfo;
                    return [4 /*yield*/, getDeviceIdAsync()];
                case 1:
                    _b.deviceId = _c.sent();
                    appInstallation.deviceInfo.deviceYearClass = null;
                    appInstallation.appInfo.installationIdGenerated = installationIdGenerated;
                    appInstallation.appInfo.installationId = installationId;
                    appInstallation.appInfo.pushNotificationToken = 'browser-token';
                    appInstallation.appInfo.pushNotificationGrantStatus = 'unsupported';
                    appInstallation.appInfo.platform = getBrowserPlatformManifest();
                    return [2 /*return*/, appInstallation];
            }
        });
    });
};

export { buildAppInstallationInfo, getBrowserPlatformManifest, getDeviceIdAsync, getInstallationId };
//# sourceMappingURL=appInstallationBuilder.js.map
